import api from './services/api'
import router from './router'
import store from './store/index'
import axios from 'axios'



export default function setup() {
    api.interceptors.request.use(function(config) {
      let source = axios['CancelToken'].source();
        const token = localStorage.getItem('token');
        config.cancelToken = source.token;
        // store.commit('cancel/ADD_CANCEL_TOKEN', source);
        //print(token)
        if(token) {
          //print('token!')
            config.headers.Authorization = `JWT ${token}`;

        }
        return config;
    }, function(err) {
        return Promise.reject(err);
    });
    //let isRefreshing = false;
    let counter = 0
    api.interceptors.response.use(
        
        response => {
          counter+=1
          if (counter > 10 && localStorage.getItem('token')){
            counter=0
          api.post('token/refresh/',{'token':localStorage.getItem('token')})
          .then( (response) => {  
              //alert(localStorage.getItem('token'))

             localStorage.setItem('token', response.data.token);
             //alert(localStorage.getItem('token'))
             api.defaults.headers.common['Authorization'] = 'JWT ' + localStorage.getItem('token');
            }
          )
          }

            //console.log(response)
          return response;
        },
        err => {
          const {
            response: { status, data }
          } = err;
          // alert(status)

          
          if (status == 401) {
            localStorage.removeItem('token')
            router.go()
          }
      
          if (status ==407){
              localStorage.removeItem('token')
              router.go()
              return null;
          }
          if (data.detail == 'Signature has expired.'){
            localStorage.removeItem('token')
            router.go()
            
          }
          else {
            console.log(data)
          }
        }
      );
}




